import { CardApiClient } from './cardApiClient';
var accountsUrls = {
    terminalsHired: '/v2/accounts/terminals_hired',
    onboardingFinished: '/v2/accounts/onboarding_finished',
    authorizationLetterUploaded: '/v2/accounts/authorization_letter_uploaded'
};
export function updateTerminalsHired(terminals) {
    return CardApiClient.patch(accountsUrls.terminalsHired, {
        terminals: terminals
    });
}
export function onboardingComplete() {
    return CardApiClient.patch(accountsUrls.onboardingFinished, {});
}
export function saveAuthLetterStorageRef(storageRef) {
    return CardApiClient.post(accountsUrls.authorizationLetterUploaded, {
        // eslint-disable-next-line @typescript-eslint/camelcase
        storage_ref: storageRef
    });
}
